import React from "react";

const TwitterOutlineRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.56 16.5C13.0319 16.5 16.0244 11.6903 16.0244 7.51994C16.0244 7.28682 16.1896 7.08015 16.402 6.98398C17.1303 6.65413 18.0749 5.74943 17.0994 4.22828C16.4531 4.57576 15.9219 4.76562 15.2103 4.99448C14.084 3.72393 12.1995 3.66269 11.0014 4.85761C10.2285 5.62819 9.901 6.77686 10.1407 7.87304C7.74851 7.74618 4.94788 5.98566 3.4375 4.01391C2.64814 5.45632 3.05107 7.30121 4.35822 8.22802C3.88461 8.21302 3.4216 8.07741 3.00807 7.83305V7.87304C3.00807 9.3755 4.00654 10.6691 5.3944 10.9666C4.95672 11.0935 4.49724 11.1122 4.05131 11.021C4.44128 12.3065 6.12974 13.7489 7.40272 13.7745C6.34887 14.6526 5.04761 15.1295 3.70806 15.1282C3.47126 15.1276 3.23504 15.1126 3 15.0826C4.36076 16.0088 5.94359 16.5 7.56 16.4975V16.5Z",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(TwitterOutlineRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;